export { VpTagInput } from './VpTagInput';



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/VpTagInput/index.js